import { ModuleRegistry, AllModules } from '@ag-grid-enterprise/all-modules'
import { LicenseManager } from '@ag-grid-enterprise/core'

LicenseManager.setLicenseKey('CompanyName=Vitro, S.A.,LicensedApplication=Anapath,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-012861,ExpiryDate=11_February_2022_[v2]_MTY0NDUzNzYwMDAwMA==8f979a34768ee5c03c3c37d7895640f2')
ModuleRegistry.registerModules(AllModules)
